import { render } from "./layout-report.vue?vue&type=template&id=022a6b20"
import script from "./layout-report.vue?vue&type=script&lang=js"
export * from "./layout-report.vue?vue&type=script&lang=js"

import "./layout-report.vue?vue&type=style&index=0&id=022a6b20&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__